<template>
    <div id="aboutUs">
        <!--公司介绍-->
        <div class="companyIntroduction">
            <div class="headline">公司介绍</div>
            <div class="companyIntroductionVal">
                深圳市豪斯莱科技有限公司成⽴于2016年8⽉，以“⾦融+科技”为核⼼理念，基于⼤数据挖掘为基础的数学建模，致⼒于为⾦融⾏业提供精准营销、客群洞察、互联⽹⻛向分析、预测⾏业趋势等服务，布局以⾦融零售为主，现阶段核⼼能⼒主要应⽤在银⾏零售业务以及部分合规贷款产品的精准线上获客，包括电⼦银⾏、信⽤卡、保险、信贷等产品，⼒争打造⾏业精准营销标杆，同时复制其模式探索赋能⾄电商、游戏⾏业。构建以数据为基础的业务⽣态，解决企业痛点，持续在企业级⼤数据服务领域探索和耕耘,不断为合作伙伴创造价值
            </div>
        </div>
        <!--愿景与使命-->
        <div class="visionAndMissionWrap">
            <!--引号-->
            <img src="../../../assets/img/aboutAndJoinUs/“.png" class="markImg markTop"/>
            <img src="../../../assets/img/aboutAndJoinUs/“.png" class="markImg markBottom"/>
            <div class="visionAndMission">
                <!--背景-->
                <img src="../../../assets/img/aboutAndJoinUs/地图.png" class="bigD" :width="smallImgW"/>
                <div class="visionAndMissionCon">
                    <div class="visionAndMissionConT">愿景和使命</div>
                    <div class="visionAndMissionConV">用数据驱动未来，构建以数据为基础的企业生态，不断为合作伙伴创造价值</div>
                </div>
            </div>
        </div>
        <!--发展历程-->
        <div class="developmentHistory">
            <div class="headline">发展历程</div>
            <div class="developmentHistoryCon">
                <img src="../../../assets/img/aboutAndJoinUs/发展历程.png" alt=""/>
                <!--2016-->
                <div class="yearBox" style="left: 61px;top: 20px;">2016</div>
                <div class="hisConBox" style="left: 205px;top: 20px;">
                    <span>08月</span>
                    <p>深圳市豪斯莱科技<br/>正式成立</p>
                </div>
                <!--2017-->
                <div class="yearBox" style="left: 407px;top: 20px;">2017</div>
                <div class="hisConBox" style="left: 547px;top: 20px;">
                    <span>07月</span>
                    <p>以电子银行分发切入金<br/>融零售分发业务领域</p>
                </div>
                <div class="hisConBox" style="left: 737px;top: 20px;">
                    <span>12月</span>
                    <p>以腾讯游戏为基础切入<br/>游戏分发领域</p>
                </div>
                <!--2018-->
                <div class="yearBox" style="left: 858px;top: 179px;">2018</div>
                <div class="hisConBox" style="left: 705px;top: 179px;">
                    <span>03月</span>
                    <p>完成早期资本股东自筹</p>
                </div>
                <div class="hisConBox" style="left: 520px;top: 179px;">
                    <span>05月</span>
                    <p>正式切入银行信用卡分发市场，并与多家银行及大分发商建立深度合作关系</p>
                </div>
                <div class="hisConBox" style="left: 337px;top: 179px;">
                    <span>06月</span>
                    <p>豪斯莱数据管理后台上线，并成功应用在100+合作伙伴</p>
                </div>
                <div class="hisConBox" style="left: 152px;top: 179px;">
                    <span>10月</span>
                    <p>卡加信用卡分发体系上线投入使用；信用卡分发单项业务营收破千万</p>
                </div>
                <!--2019-->
                <div class="yearBox" style="left: 61px;top: 338px;">2019</div>
                <div class="hisConBox" style="left: 186px;top: 338px;">
                    <span>01月</span>
                    <p>成立豪斯莱魅塔<br/>(META)大数据中心</p>
                </div>
                <div class="hisConBox" style="left: 366px;top: 338px;">
                    <span>03月</span>
                    <p>豪斯莱智能营销画像建模完成，初步测试完毕，进入验证业务及新业务投入期</p>
                </div>
                <div class="hisConBox" style="left: 575px;top: 338px;">
                    <span>09月</span>
                    <p>获得国家高新认证，同时以大数据能力为核心推出智能营销体系及产品矩阵</p>
                </div>
                <div class="hisConBox" style="left: 771px;top: 338px;">
                    <span>第四季度</span>
                    <p>魅塔(META)大数据开始产生独立营收</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "aboutUs",
        data() {
            return {
                translateObj: {
                    transform: "translateX(0)"
                },
                translateIndex: 0,
                showBigImgFlag: false,
                smallImgW: 394,
                scrollAction: {
                    y: 'undefined'
                }
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            /*右箭头事件*/
            rightEvent() {
                if (this.translateIndex >= 2) {
                    return
                }
                this.translateIndex++;
                let translateNum = this.translateIndex * -760;
                this.translateObj.transform = `translateX(${translateNum}px)`;
            },
            /*左箭头事件*/
            leftEvent() {
                if (this.translateIndex <= 0) {
                    return
                }
                this.translateIndex--;
                let translateNum = this.translateIndex * -760;
                this.translateObj.transform = `translateX(${translateNum}px)`;
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("companyIntroduction")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("visionAndMission")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("developmentHistory")[0], "fadeInUp");

                /*地图大小变化*/
                /*滑动距离*/
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                // 判断滑动方向
                if (typeof this.scrollAction.y == 'undefined') {
                    this.scrollAction.y = window.scrollY;
                }
                let diffY = this.scrollAction.y - window.scrollY;
                if (diffY < 0) {
                    console.log("下");
                    if (scrollTop >= 60) {
                        this.smallImgW += 1;
                    }
                    if (this.smallImgW >= 500) {
                        this.smallImgW = 500;
                    }
                } else if (diffY > 0) {
                    console.log("上");
                    if (this.smallImgW > 394) {
                        this.smallImgW -= 1;
                        if (this.smallImgW <= 394) {
                            this.smallImgW = 394;
                        }
                    }
                }
                this.scrollAction.y = window.scrollY;
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #aboutUs {
        width: 1200px;
        padding-top: 70px;
        margin: 0 auto;

        .companyIntroduction {
            margin-bottom: 120px;

            .companyIntroductionVal {
                opacity: 0.7;
                font-size: 14px;
                color: #152346;
                line-height: 24px;
                text-align: justify;
            }
        }

        .visionAndMissionWrap {
            position: relative;
            height: 240px;
            margin-bottom: 100px;
            background: #F6F9FF;

            .markImg {
                position: absolute;
            }

            .markTop {
                left: 135px;
                top: -10px;
                transform: rotate(180deg);
            }

            .markBottom {
                right: 135px;
                bottom: -10px;
            }
        }

        .visionAndMission {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            height: 100%;

            .bigD {
                position: absolute;
                left: 50%;
                top: 0;
                transform: translateX(-50%);
            }

            .visionAndMissionCon {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                margin-top: -12px;
                text-align: center;

                .visionAndMissionConT {
                    margin-bottom: 30px;
                    font-size: 30px;
                    color: #152346;
                    line-height: 32px;
                }

                .visionAndMissionConV {
                    font-size: 18px;
                    color: #5B657D;
                    line-height: 28px;
                }
            }
        }

        .developmentHistory {
            position: relative;
            text-align: center;

            .developmentHistoryCon {
                position: relative;
                display: inline-block;
                text-align: center;
                padding-bottom: 40px;

                .yearBox {
                    position: absolute;
                    font-size: 20px;
                    color: #152346;
                    line-height: 24px;
                }

                .hisConBox {
                    position: absolute;
                    text-align: left;

                    span {
                        display: inline-block;
                        font-size: 12px;
                        font-weight: bold;
                        color: #5B657D;
                        line-height: 24px;
                    }

                    p {
                        max-width: 120px;
                        font-size: 12px;
                        color: #5B657D;
                        line-height: 18px;
                    }
                }
            }
        }
    }
</style>
